import dayjs from "dayjs";
import durationPlugin from "dayjs/plugin/duration";

dayjs.extend(durationPlugin);

export const humanReadableTime = (
  value: number | string | null | undefined,
) => {
  if (value === null || value === undefined) return "";
  const ms = typeof value === "string" ? Number(value) : value;
  if (Number.isNaN(ms)) return "";

  const dur = dayjs.duration(ms);

  const seconds = dur.asSeconds();
  const minutesTotal = dur.asMinutes();
  const hoursTotal = dur.asHours();
  const daysTotal = dur.asDays();

  if (seconds < 60) return "Less than one minute";
  if (hoursTotal < 1) return `${Math.floor(minutesTotal)} minutes`;
  if (daysTotal < 1) return `${dur.hours()} hours ${dur.minutes()} minutes`;
  return `${dur.days()} days ${dur.hours()} hours ${dur.minutes()} minutes`;
};
